import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useAuth0 } from '@auth0/auth0-react';
import translate from "../../common/Dictionary";

import handleResponse from '../../common/ResponseHandler'
import { UserContext } from '../../../auth/auth0-provider-with-history';

const EditProjectService = (props) => {
    const [state, setState] = useState({
        updateLoading: false,
        serviceCategories: [],
        selectedCatId: 0,
        selectedSubcatId: 0,
        selectedServiceId: 0,
        updateServiceLoading: false
    });

    const { getAccessTokenSilently } = useAuth0();
    const { userData } = useContext(UserContext);

    const saveChanges = async () => {
        try {
            var token = await getAccessTokenSilently();
            const response = await axios.get(`api/homeproject/updateservice/${props.projectId}/${state.selectedServiceId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            handleResponse(response, "Error Loading Login Data");
            if (!response.data.isError) {
                await setState({
                    ...state,
                    loginUserData: response.data.data
                });
            }
            props.getHomeProject();
        } catch (error) {
            toast.error("Error Loading Login Data", { toastId: "error-loading-login-data" });
        }
    };

    const getServices = async () => {
        const serviceResponse = await axios.get("api/servicecategory/getallactive");
        setState({
            ...state,
            serviceCategories: serviceResponse.data.data,
        });
    }

    const updateServiceCat = (catId) => {
        setState({ ...state, selectedCatId: catId });
    }

    const updateServiceSubCat = (subCatId) => {
        setState({ ...state, selectedSubcatId: subCatId });
    }

    const updateService = (serviceId) => {
        setState({ ...state, selectedServiceId: serviceId });
    }

    useEffect(() => {
        getServices();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="container">
            <div className="row">
                <div className="title-sub-text align-left pt-1 col-12">
                    <div className="row">
                        <div className="col-md-8 col-sm-12">
                            <select
                                id="select-service-category"
                                value={state.selectedCatId}
                                className="form-select text-primary"
                                onChange={(event) => updateServiceCat(event.target.value)}
                            >
                                <option className="text-black" value={0} style={{ display: (state.selectedCatId === 0 ? "" : "none") }}>{translate("newProjectSelectMakeASelectionText", userData.language)}</option>
                                {state.serviceCategories?.map((cat, index) => {
                                    return (
                                        <option
                                            key={"catOption-" + index}
                                            className="text-black"
                                            value={cat.id}
                                        >
                                            {translate(cat.code, userData.language)}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                </div>
                <div style={{ display: state.selectedCatId !== 0 ? "" : "none" }} className="col-12">
                    <div className="title-sub-text align-left pt-3">
                        <label htmlFor="select-service-subcategory">{translate("newProjectLabelSubCategory", userData.language)}</label>
                    </div>
                    <div className="title-sub-text align-left pt-1">
                        <div className="row">
                            <div className="col-md-8 col-sm-12">
                                <select
                                    id="select-service-subcategory"
                                    value={state.selectedSubcatId}
                                    className="form-select text-primary"
                                    onChange={(event) => updateServiceSubCat(event.target.value)}
                                >
                                    <option className="text-black" value={0} style={{ display: (state.selectedSubcatId === 0 ? "" : "none") }}>{translate("newProjectSelectMakeASelectionText", userData.language)}</option>
                                    {state.serviceCategories?.find(x => x.id === parseInt(state.selectedCatId))?.serviceSubCategories?.map((cat, index) => {
                                        return (
                                            <option
                                                key={"catOption-" + index}
                                                className="text-black"
                                                value={cat.id}
                                            >
                                                {translate(cat.code, userData.language)}
                                            </option>)
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: state.selectedSubcatId !== 0 ? "" : "none" }} className="col-12">
                    <div className="title-sub-text align-left pt-3">{translate("newProjectLabelService", userData.language)}</div>
                    <div className="axa-under-text align-left">{translate("newProjectLabelServiceUnderText", userData.language)}</div>
                    <div className="title-sub-text align-left pt-1">
                        <div className="row">
                            {state.serviceCategories?.find(x => x.id === parseInt(state.selectedCatId))?.serviceSubCategories?.find(x => x.id === parseInt(state.selectedSubcatId))?.services.map((service, index) => {
                                return (
                                    <div
                                        key={"serviceRadio-" + index}
                                        className="col-md-4 col-12 d-grid mt-2 axa-service-selection-button-height"
                                    >
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            name="optionsService"
                                            id={"option-" + index}
                                            value={service.id}
                                            checked={service.id === parseInt(state.selectedServiceId)}
                                            onChange={(event) => updateService(event.target.value)}
                                        />
                                        <label className="btn btn-outline-primary axa-service-radio-label" htmlFor={"option-" + index}>
                                            {translate(service.code, userData.language)}
                                        </label>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div style={{ display: state.selectedServiceId === 0 ? "none" : "" }} className="col-12 mt-2" align="right">
                    <button
                        disabled={state.updateServiceLoading}
                        className="btn btn-outline-success"
                        onClick={saveChanges}>Update Service
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditProjectService;